import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { formatCurrency, formatDate, priceReview } from "../../../utils";
import Logo from "../../../../src/assets/images/logo.png";
import moment from "moment";
import paidStamp from "../../../assets/images/paid-stamp.png";
import { Request, RequestType } from "../../../models/request.model";
import { UserAnnualPlanState } from "../../../models/user-annual-plan.model";
import InvoiceOfficeHeader from "./InvoiceOfficeHeader";

const InvoicePatientPdf = ({ request }: { request?: Request }) => {
  const { requestData: officeRequest, requestPatient, invoiceObject: officeInvoiceObject } = useSelector((state: RootState) => state.officeRequest);
  const { invoiceObjectOnboarding, selectedOffice: guestOffice } = useSelector((state: RootState) => state.onBoarding);
  const authenticatedOffice = useSelector((state: RootState) => state.office.currentOffice);

  // Use guest data if available, otherwise use authenticated data
  const invoiceObject = officeInvoiceObject || invoiceObjectOnboarding;
  const currentOffice = authenticatedOffice || guestOffice;

  const {
    servicePrice,
    dscDesc,
    dscValue,
    blockFeeDiscountDesc,
    blockFeeDiscountAmount,
    subTotal,
    hstValue,
    hstPercentage,
    hstDesc,
    total,
    dsFee,
    dsFeeDesc,
  } = priceReview(invoiceObject ? invoiceObject : undefined);
  const requestData = request ? request : officeRequest;
  const showAnnualPlanDiscount =
    requestData?.paymentComplete && requestPatient?.userAnnualPlan?.userAnnualPlanState === UserAnnualPlanState.Active
      ? !moment(requestData.paymentDate).isBefore(moment(requestPatient.userAnnualPlan.startDate))
      : true;
  return (
    <>
      <div className="w-full h-a4 flex flex-col  ">
        <div className="px-8">
          <div className="flex justify-between">
            <span>
              <img src={Logo} alt="" className="w-48" />
            </span>
            <span>
              <img src={paidStamp} alt="" className="w-36 h-14" />
            </span>
          </div>
          <div className="flex justify-between">
            <p className="text-lg font-semibold mb-1 py-2">Invoice #{requestData?.requestNumber}</p>
            <p className="text-lg font-semibold mb-1 py-2">Date: {moment(requestData?.createdDate).format("ll")}</p>
          </div>
          <div id="invoice-details">
            <InvoiceOfficeHeader office={currentOffice} showHstAlways />
          </div>
          {requestData?.requestType === RequestType.DocnoteDebit && requestData.primaryCareProvider && (
            <div>
              {" "}
              <p className="text font-semibold">
                {requestData.primaryCareProvider.firstName} {requestData.primaryCareProvider.lastName}
              </p>
            </div>
          )}

          <div id="invoice-patient-details" className="mt-3 mb-5">
            <p className="text font-semibold">Patient Details:</p>
            <p>
              {requestData?.firstName} {requestData?.lastName}
            </p>
            <p>Date of Birth: {formatDate(requestData?.dateOfBirth ? requestData?.dateOfBirth : "", "PP")}</p>
          </div>
        </div>
        <div id="invoice-fee" className="py-2  px-8" style={{ backgroundColor: "#F5F5F5" }}>
          <p className="text font-semibold mb-3">Fees</p>
        </div>

        <div className="px-8">
          <div className="flex">
            <p className="w-full">{requestData?.service?.name}</p>
            <p className="right-0 mr-0 ml-auto">${(servicePrice || 0).toFixed(2)}</p>
          </div>
          <div>
            {invoiceObject?.fees?.map((fee, index) => (
              <div className="flex" key={index}>
                <p className="w-full">{fee?.description}</p>
                <p className="right-0 mr-0 ml-auto">${(fee.amount / 100).toFixed(2)}</p>
              </div>
            ))}
          </div>
          <hr className="border border-black mt-4 mb-4" />
          <>
            {dscValue > 0 ? (
              <div className="flex">
                <p className="py-0.5 w-full ml-[50%]">{dscDesc}</p>
                <p className="right-0 mr-0 font-bold">{formatCurrency(dscValue.toString(), "blur")}</p>
              </div>
            ) : null}
            {blockFeeDiscountAmount > 0 && showAnnualPlanDiscount ? (
              <div className="flex">
                <p className="py-0.5 w-full ml-[50%]">Annual Plan: {blockFeeDiscountDesc}</p>
                <p className="right-0 mr-0 font-bold">{formatCurrency(blockFeeDiscountAmount.toString(), "blur")}</p>
              </div>
            ) : null}
            <div className="flex">
              <p className="py-0.5 w-full ml-[50%]">Subtotal</p>
              <p className="right-0 mr-0">{formatCurrency(subTotal.toString(), "blur")}</p>
            </div>
            {hstValue > 0 ? (
              <div className="flex">
                <p className="py-0.5 w-full ml-[50%]">{hstDesc ? `${hstDesc} (${hstPercentage ? `${hstPercentage}%` : ""})` : "HST"}</p>
                <p className="right-0 mr-0">{formatCurrency(hstValue.toString(), "blur")}</p>
              </div>
            ) : null}
            {dsFee > 0 ? (
              <div className="flex">
                <p className="py-0.5 w-full ml-[50%]">{dsFeeDesc}</p>
                <p className="right-0 mr-0">{formatCurrency(dsFee.toString(), "blur")}</p>
              </div>
            ) : null}
            <hr className="border border-black mt-4 mb-4" />
          </>
          <div className="flex">
            <p className="py-0.5 w-full ml-[50%] font-semibold">Invoice total</p>
            <p className="right-0 mr-0 font-semibold">${total.toFixed(2)}</p>
          </div>
        </div>
      </div>
      <div>
        {" "}
        <p className="text-xs text-center text-docsigna-purple">481 London Road, Unit 109, Sarnia, ON N7T 4X3 HST # 703533687 RT 0001</p>
        <p className=" text-xs text-center text-docsigna-purple mb-5">This service has been provided by Docnote Inc.</p>
      </div>
    </>
  );
};

export default InvoicePatientPdf;
